/* Back-to-store button, top left of the Track page.
   Own asset so the page section stays untouched. */
(function(){
function add(){
var host=document.getElementById('cd-track');
if(!host||document.getElementById('cd-back'))return;
var a=document.createElement('a');
a.id='cd-back';
a.href='/';
a.setAttribute('style','position:absolute; top:clamp(14px,3vw,24px); left:clamp(14px,3vw,24px); z-index:20; display:inline-flex; align-items:center; gap:8px; background:#0d2340; color:#f4e8c8; text-decoration:none; font-family:Anton, sans-serif; font-size:15px; letter-spacing:0.5px; padding:11px 18px 11px 14px; border-radius:999px; min-height:44px; box-shadow:0 6px 16px rgba(13,35,64,0.25);');
a.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M15 5 8 12l7 7"></path></svg><span>BACK TO STORE</span>';
a.onmouseenter=function(){a.style.background='#b1272f';};
a.onmouseleave=function(){a.style.background='#0d2340';};
host.style.position='relative';
host.insertBefore(a,host.firstChild);
/* on narrow screens shrink to just the arrow so it never crowds the logo */
function fit(){
var label=a.querySelector('span');
if(!label)return;
if(window.innerWidth<520){label.style.display='none';a.style.padding='11px 13px';}
else{label.style.display='inline';a.style.padding='11px 18px 11px 14px';}
}
window.addEventListener('resize',fit);
fit();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',add);}else{add();}
setTimeout(add,400);
})();
